import {useQuery} from 'react-query';
import {TopicVO, ServicesApi} from '../api';
import {useMapioContext} from '../mapioContext';

export const CACHE_KEY_TOPICS_CONFIG = 'CACHE_KEY_TOPICS_CONFIG';

// Od useTopicsMap se liší tím, že do témat neplní defaultní hodnoty, když nejsou na tématu nastavené
export const useTopicsConfig = () => {
    const mapioContext = useMapioContext();
    const {context} = mapioContext.value;

    return useQuery<TopicVO[]>([CACHE_KEY_TOPICS_CONFIG], async () => (await ServicesApi.getTopicsConfig(context)).data, {
        // Konfigurace témat je v rámci session statická – refetch na focus okna nechceme (reset viditelnosti vrstev).
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    });
};
